<template>
  <div>
    <div v-if="$auth.policies['view-teaching-progress-report']">
      <div>
        <div class="pa-4 d-flex justify-space-between align-center">
          <div>
            <Breadcrumbs
              headline="Báo cáo tiến độ giảng dạy"
              :link="[
                {
                  text: 'Báo cáo tiến độ giảng dạy',
                  href: '../teaching-progress-report',
                },
              ]"
            />
          </div>
        </div>

        <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
          <TeachingProgressReportFilter @onFilterChanged="onFilterChange" />
        </v-card>

        <v-card outlined class="mx-4 elevation-0">
          <TeachingProgressReportDataTable ref="teachingProgressReportDataTable" />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeachingProgressReportDataTable from '@/modules/teachingPlan/TeachingProgressReportDataTable.vue'
import TeachingProgressReportFilter from '@/modules/teachingPlan/TeachingProgressReportFilter.vue'

export default {
  components: {
    Breadcrumbs,
    TeachingProgressReportDataTable,
    TeachingProgressReportFilter,
  },
  props: {},
  data() {
    return {
      showHistory: false,
    }
  },
  computed: {},
  methods: {
    async refresh(query) {
      this.$refs.teachingProgressReportDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    },
  },
  async created() {},
}
</script>
